import { Pipe, PipeTransform } from "@angular/core";
import { currencySymbols } from "@app/helper/i18utils";
import { StoreService } from 'src/app/services/store/store.service';

@Pipe({
  name: 'currencyRate'
})
export class CurrencyRatePipe implements PipeTransform {

  constructor(private store: StoreService) { }

  transform(amount: number | string, showSymbol = false, onlyUSD = false, fromCurrency: string = 'USD', toCurrency?: string) {
    let result: any = Number(amount);
    let symbol = '$';
    let user = this.store.getUser();
    const currencyRates = this.store.getCurrencyRates()?.currencyRates;
    toCurrency = toCurrency ? toCurrency.toUpperCase() : user?.Customer?.currency?.length ? user.Customer.currency.toUpperCase() : 'USD';

    if ((result || result == 0) && fromCurrency?.toUpperCase() != toCurrency && currencyRates) {
      const fromRate = currencyRates[fromCurrency?.toLowerCase()] || 1;
      const toRate = currencyRates[toCurrency?.toLowerCase()] || 1;

      // Convert from loggedIn customer currency to USD
      if (onlyUSD) {
        result = Number((result / toRate).toFixed(2));
        return result;
      }

      // Convert from source currency to USD, then to target currency
      const amountInUsd = result / fromRate;
      result = Number(amountInUsd * toRate).toFixed(2);

      if (currencySymbols && currencySymbols[toCurrency]) {
        symbol = currencySymbols[toCurrency];
      }
    }
    if (amount == 0 || fromCurrency?.toUpperCase() == toCurrency) {
      symbol = currencySymbols[toCurrency];
    }

    if (showSymbol) {
      if (amount === '') {
        result = `${symbol}`;
      } else {
        if (result == -0.00) { // Remove (-) sign If converted amount is less than 0.00 (i.e., 0.0012)
          result = `${symbol}0.00`;
        } else {
          result = result >= 0 ? `${symbol}${result}` : result < 0 ? `-${symbol}${result * -1}` : `${symbol}`;
        }
      }
    }

    return result;
  }
}
